import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.IntroductionVideo', {
    titleXero: 'Watch this video to get a quick overview of ApprovalMax features for Xero',
    titleQbooks: 'Watch this video to get a quick overview of ApprovalMax features for QuickBooks Online',
    titleOther: 'Watch this video to get a quick overview of ApprovalMax features',
});
